import { Document } from '../types';
import { DocumentCard } from './DocumentCard';

interface DocumentGridProps {
  documents: Document[];
  onPreview?: (uuid: string) => void;
  onDownload?: (document: Document) => void;
  onDelete?: (uuid: string) => void;
  onEdit?: (document: Document) => void;
}

export const DocumentGrid: React.FC<DocumentGridProps> = ({
  documents,
  onPreview,
  onDownload,
  onDelete,
  onEdit,
}) => {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {documents.map((document) => (
        <DocumentCard
          key={document.uuid}
          document={document}
          onPreview={onPreview}
          onDownload={onDownload}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </div>
  );
};

